import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { EventBus } from '@/utils';
import { Data } from './data';
import { Helper } from './helper';

export class UniperConnection {
    // Local connection for development, replaced with env variable
    private static url: string | undefined = process.env.VUE_APP_UNIPER_URL;

    private eohApi: AxiosInstance;
    private token: string;
    private data: Data;

    public constructor() {
        this.data = Data.Instance;
        this.token = '';
        this.eohApi = axios.create({
            baseURL: UniperConnection.url,
        });

        this.eohApi.interceptors.request.use(async (config) => {
            const authHeader = 'Bearer ' + this.token;
            config.headers['Authorization'] = authHeader;
            config.headers['Accept-Language'] = this.data.getLanguage();

            return config;
        });

        this.eohApi.interceptors.response.use(
            (success) => {
                return success;
            },
            (error) => {
                if (
                    !navigator.onLine ||
                    error === undefined ||
                    error.response === undefined ||
                    error.response?.status === undefined
                ) {
                    EventBus.$emit(EventBus.GLOBAL.SHOW_SNACKBAR, {
                        class: 'error',
                        message: 'checkNetwork',
                        translate: true,
                    });
                } else if (
                    error.response?.status === 401 ||
                    error.response?.status === 403
                ) {
                    Helper.removeOpenBackdrops();
                    EventBus.$emit(EventBus.GLOBAL.SHOW_SNACKBAR, {
                        class: 'error',
                        message: 'unauthorized',
                        translate: true,
                    });
                }
                return Promise.reject(error);
            }
        );
    }

    public get(url: string, config?: AxiosRequestConfig): Promise<any> {
        return this.eohApi.get(url, config);
    }

    public post(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<any> {
        return this.eohApi.post(url, data, config);
    }

    public put(
        url: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<any> {
        return this.eohApi.put(url, data, config);
    }

    public delete(url: string, config?: AxiosRequestConfig): Promise<any> {
        return this.eohApi.delete(url, config);
    }

    public setToken(token: string): void {
        this.token = token;
    }
}
